<template>
  <path id="body-path" class="body-path" :d="bodyPath" style="stroke-width: 13.75px;" />
</template>

<script>

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";

export default {
  name: "logo",
  props: [
    'convertedWindowSize',
    'windowWidth',
    'windowHeight',
  ],
  data() {
    return {
      toggleHor1: window.innerWidth < 400 ? -225 : -200,
      toggleHor2: window.innerWidth < 400 ? 330 : 300,
      toggleVert: null, 
      saveProjectsHeight: null,
      isOpen: false,
    };
  },
  computed: {
    projectsHeight() {
      if (!this.convertedWindowSize) return 603.5;
      let offset = gsap.getProperty(".section-3", "paddingBottom") + gsap.getProperty(".section-4", "height") + gsap.getProperty(".section-5", "paddingTop")*.6
      let convertedOffset = this.convertToSVGPoint(0, offset).y - this.convertToSVGPoint(0, 0).y + 26; //26 accounts for curve distance
      if (!this.toggleVert) {
        return this.getSVGRect("#project-links").height + convertedOffset;
      }
      return this.toggleVert + convertedOffset;
    },
    bodyPath() {
      if (!this.convertedWindowSize) return "M387.35,387.76v172.47a26.7,26.7,0,0,1,-26.7,26.6h-313.7a26.7,26.7,0,0,0,-26.6,26.7v67.2a26.6,26.6,0,0,0,26.6,26.6h313.7a26.8,26.8,0,0,1,26.7,26.7v433.83648191293764a26.7,26.7,0,0,1,-26.7,26.6h-200a26.6,26.6,0,0,1,-26.6,-26.6v-67.9a26.6,26.6,0,0,0,-26.6,-26.6h-149.8a26.6,26.6,0,0,0,-26.6,26.6v196.4a26.6,26.6,0,0,0,26.6,26.6h0a26.6,26.6,0,0,0,26.6,-26.6v-143.1a26.6,26.6,0,0,1,26.6,-26.6h0.6a26.6,26.6,0,0,1,26.6,26.6v383.834a32.3,32.3,0,0,0,32.3,32.3h300a28.4,28.4,0,0,1,28.5,28.5v174.9";
      let section1 = this.getSVGRect(".section-1");
      let section2 = this.getSVGRect(".section-2");
      let intro = this.getSVGRect("#intro-text");
      let introMarginTop = (section1.height - intro.height)/2;
      let bodyPathStartY = this.windowHeight - 1;
      let introVert1 = introMarginTop - (intro.height*1.25);
      let paddingDistance1 = this.convertToSVGPoint(0, gsap.getProperty(".section-3", "paddingTop")).y - this.convertToSVGPoint(0, 0).y
      //let paddingDistance2 = this.convertToSVGPoint(0, gsap.getProperty(".section-5", "paddingTop")).y - this.convertToSVGPoint(0, 0).y
      let introVert2 = introVert1 + section2.height + (paddingDistance1 *.75);
      //let toggleVert1 = this.getSVGRect(".section-3").height - paddingDistance1 + 26 + this.getSVGRect(".section-4").height + paddingDistance2*.6;
        return `M387.35,${bodyPathStartY}
                v${introVert1}a26.7,26.7,0,0,1,-26.7,26.6h-313.7a26.7,26.7,0,0,0,-26.6,26.7v67.2a26.6,26.6,0,0,0,26.6,26.6h313.7a26.8,26.8,0,0,1,26.7,26.7
                v${introVert2}a26.7,26.7,0,0,1,-26.7,26.6
                h${this.toggleHor1}a26.6,26.6,0,0,1,-26.6,-26.6v-68a26.6,26.6,0,0,0,-26.6,-26.6h-149.8a26.6,26.6,0,0,0,-26.6,26.6v196.4a26.6,26.6,0,0,0,26.6,26.6h0a26.6,26.6,0,0,0,26.6,-26.6v-143.1a26.6,26.6,0,0,1,26.6,-26.6h0.6a26.6,26.6,0,0,1,26.6,26.6
                v${this.projectsHeight}a32.3,32.3,0,0,0,32.3,32.3
                h${this.toggleHor2}a28.4,28.4,0,0,1,28.5,28.5v${this.windowHeight * .4}`
    }
  },
  methods: {
    toggleBodyPath(listItem) {
        let listItemBox = this.SVGBoundingClientRect(listItem, this.$refs.animatedLogo);
        let distanceX = window.innerWidth < 400 ? 0 : window.innerWidth < 800 ? this.convertedWindowSize.width *  .05 : this.convertedWindowSize.width * .2 ;
        let horizontal1 = window.innerWidth < 400 ? -225 : -200;
        let horizontal2 = window.innerWidth < 400 ? 330 : 300;
        if (this.isOpen) { distanceX = distanceX*-1 }

        let tl = gsap.timeline({
            onComplete: ()=> {
              ScrollTrigger.getById("section2").animation.invalidate();
              ScrollTrigger.getById("detailsSection").animation.invalidate();
              gsap.getById("bounce2").invalidate();
              if(this.isOpen){
                this.isOpen = false;
                this.toggleVert = null
              }
              else {this.isOpen = true;}
              gsap.to(window, {duration: .05, scrollTo: {y: "+=1"}})
            },
        });
        tl.to(this.$data, {
            duration: .25, 
            toggleHor1: this.isOpen ? horizontal1 : horizontal1 - distanceX,
            toggleHor2: this.isOpen ? horizontal2 : horizontal2 + distanceX, 
            toggleVert: this.isOpen ? this.saveProjectsHeight : listItemBox.height
        }, "<")
        tl.to(".svg-container .body-target", {duration: .25, x: `-=${distanceX}`}, "<");
        tl.to("#body-path", {duration: .25, drawSVG: DrawSVGPlugin.getPosition("#body-path")[1] + distanceX}, "<");

        return tl
    },
    getSVGRect(selector){
      return this.SVGBoundingClientRect(document.querySelector(selector))
    },
  },
  mounted() {
    document.fonts.ready.then(() => { 
      this.saveProjectsHeight = this.projectsHeight;
      
      this.$root.$on('toggleBodyPath', (listItem) => {
        this.toggleBodyPath(listItem);
      });
      this.$root.$on('beforeRefresh', (activeItem) => {
          //return to start values before ScrollTrigger refresh
          if(activeItem) this.toggleBodyPath(activeItem).progress(0);
      });
    });
  }
}
</script>

<style lang="less">

</style>